import { useTranslation } from 'react-i18next';

import type { Client } from '~/api/clients/types';

import { Icon } from '~/components';
import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { clientTypeCellStyle } from './clientCell.css';

type Props = {
  type: Client['clientType'];
};

export const ClientTypeCell = ({ type }: Props) => {
  const { t } = useTranslation(['clients']);

  return (
    <div className={clsx(desktopTruncateStyle, clientTypeCellStyle)}>
      <Icon name={type === 'organisation' ? 'Company' : 'Person'} size={20} />

      <span>{t(`clients:type.${type}`)}</span>
    </div>
  );
};
